import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useDeleteFutureBillingPlan = (orgId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: async (planId: string) => {
      const response = await fetch(
        `${APIBaseChronos}/api/org/${orgId}/billing-plan/${planId}`,
        getFetchConfig({ method: FetchMethod.DELETE }),
      );
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.message || 'Failed to delete billing plan');
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries([QueryEntity.OrganisationById, { orgId }]);
      queryClient.invalidateQueries([QueryEntity.OrganisationBillingPlanHistory, { orgId }]);
      toast.success('Scheduled billing plan deleted');
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
};
